<template>
  <div>
    <loading-state :state="state"></loading-state>
    <div>
      <div class="title-and-tools">
        <div class="tools">
          <button class="clean full symbol-btn" :disabled="showTeamWisePlayers" @click="isMiniView = !isMiniView">↕</button>
          <button class="tag switch-btn" :class="!showTeamWisePlayers ? 'active': ''" @click="showTeamWisePlayers = false">Group by Role</button>
          <button class="tag switch-btn" :class="showTeamWisePlayers ? 'active': ''" @click="showTeamWisePlayers = !showTeamWisePlayers">Group by Team</button>
        </div>
        <h2 v-if="credit && credit.grouped">Fantasy Player Credits</h2>
        <h2 v-if="points">Fantasy Player Points</h2>
      </div>
      <div v-if="credit && credit.grouped">
        <div v-if="!showTeamWisePlayers">
          <div
            class="page-space"
            v-for="role in credit.grouped"
            v-if="role.players.length"
            :key="role.name">
            <h5 class="bottom-space">{{role.name}}</h5>
            <div class="boxes keep-left">
              <div 
                class="box filled min-width"
                v-for="playerKey in role.players" :key="playerKey">
                <div>
                  <div 
                    class="clickable head"
                    @click="onPlayerSelected(playerKey)">{{credit.players[playerKey].name}} ({{credit.teams[credit.players[playerKey].team_key].short_name}})</div>

                  <div class="boxes compact width30 big-numbers" v-if="isMiniView">
                    <div><div class="highlight">{{credit.players[playerKey].fantasyCredit.credit_value | locale}}</div><label>Credit</label></div>
                  </div>
                  <template v-else>
                    <div class="boxes compact width30 big-numbers">
                      <div><div class="highlight">{{credit.players[playerKey].fantasyCredit.credit_value | locale}}</div><label>Credit</label></div>
                      <div><div>{{credit.players[playerKey].fantasyCredit.rank_in_match | locale}}</div><label>Rank</label></div>
                      <div><div>{{credit.players[playerKey].fantasyCredit.season_points | locale('-')}}</div><label>Season</label></div>
                    </div>
                    <div class="sub-head">Recent Points</div>
                    <div class="boxes compact">
                      <div class="max-240">
                        <span
                          class="silent"
                          v-for="(prevPoints, index) in credit.players[playerKey].fantasyCredit.prev_points" :key="index"
                          ><router-link
                            class="clean colored tag"
                            :to="{name:'cricketMatch', params:{key:prevPoints.match_key}}">{{prevPoints.points | locale}}</router-link>.
                        </span>
                      </div>
                    </div>
                    <div class="sub-head">Recent ranks</div>
                    <div class="boxes compact">
                      <div class="max-240">
                        <span
                          class="silent"
                          v-for="(prevPoints, index) in credit.players[playerKey].fantasyCredit.prev_points" :key="index"
                          ><router-link
                            class="clean colored tag"
                            :to="{name:'cricketMatch', params:{key:prevPoints.match_key}}">{{prevPoints.match_rank | locale}}</router-link>.
                        </span>
                      </div>
                    </div>
                  </template>


                  <div
                    class="boxes compact width30"
                    v-if="appState.fantasy.showEdit"
                  >
                    <fantasy-add-to-team-button
                      :playerKey="playerKey"
                      :credit="credit.players[playerKey].fantasyCredit.credit_value"
                    ></fantasy-add-to-team-button>
                  </div>
                  <div class="foot" alt="Last updated Match Time" v-if="!isMiniView">
                    <small>{{credit.players[playerKey].fantasyCredit.lastUpdated | simpleDateTimeString}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-space" v-if="showTeamWisePlayers">
        <section class="fullwidth">
          <div :class="[item[1]]" v-for="item in [
            ['a', 'part-first'],
            ['b', 'part-last'],]"
            :key="item.$index">
            <h5 v-if="match.teams && match.teams[item[0]] && match.teams[item[0]].match && match.teams[item[0]].match.players">{{match.teams[item[0]].match.players.length}} players</h5>
            <div
              v-for="role in credit ? match.fantasyPlayersByRole(credit.players, item[0]) : match.fantasyPlayersByRole(points.players, item[0])"
              v-if="role.players.length"
              :key="role.name">
              <h5 class="top-space silent">{{role.name}}</h5>
              <ul>
                <li v-for="playerKey in role.players" :key="playerKey">
                  <span
                    class="clickable"
                    @click="onPlayerSelected(playerKey)">
                    <span class="info" v-if="item[0] === 'a' && match.teams[item[0]].match.captain === playerKey">(captain)</span>
                    <span v-if="credit && item[0] === 'a'" class="highlight">({{credit.players[playerKey].fantasyCredit.credit_value | locale}})</span>
                    <span v-if="points && item[0] === 'a'" class="highlight">({{points.players[playerKey].fantasyPoints.match_points | locale('-')}})</span>
                    <span v-if="match.players[playerKey]">{{match.players[playerKey].name}}</span>
                    <span v-else style="color: red;">{{playerKey | capitalise}}</span>
                    <span v-if="credit && item[0] === 'b'" class="highlight">({{credit.players[playerKey].fantasyCredit.credit_value | locale}})</span>
                    <span v-if="points && item[0] === 'b'" class="highlight">({{points.players[playerKey].fantasyPoints.match_points | locale('-')}})</span>
                    <span class="info" v-if="item[0] === 'b' && match.teams[item[0]].match.captain === playerKey">(captain)</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
      <div v-if="!showTeamWisePlayers">
        <div v-if="points">
          <div
            class="page-space"
            v-for="role in points.grouped"
            v-if="role.players.length"
            :key="role.name">
            <h5 class="bottom-space">{{role.name}}</h5>

            <div class="boxes keep-left">
              <div 
                class="box filled min-width"
                v-for="playerKey in role.players" :key="playerKey">
                <div>
                  <div 
                    class="clickable head"
                    @click="onPlayerSelected(playerKey)">{{points.players[playerKey].name}} ({{points.teams[points.players[playerKey].team_key].short_name}})</div>
                  <div class="boxes compact width30 big-numbers">
                    <div><div class="highlight">{{points.players[playerKey].fantasyPoints.match_points | locale('-')}}</div><label>points</label></div>
                    <div><div>{{points.players[playerKey].fantasyPoints.season_points | locale('-')}}</div><label>Season</label></div>
                  </div>
                  <template v-if="!isMiniView" >
                    <div class="sub-head">Breakup</div>
                    <div class="boxes compact width30">
                      <div><div>{{points.players[playerKey].fantasyPoints.calculation.bat | locale('-')}}</div><label>Bat</label></div>
                      <div><div>{{points.players[playerKey].fantasyPoints.calculation.bowl | locale('-')}}</div><label>Bowl</label></div>
                      <div><div>{{points.players[playerKey].fantasyPoints.calculation.field | locale('-')}}</div><label>Field</label></div>
                    </div>
                    <div class="boxes compact width30">
                      <div><div>{{points.players[playerKey].fantasyPoints.calculation.playing_xi | locale('-')}}</div><label>XI</label></div>
                      <div><div>{{points.players[playerKey].fantasyPoints.calculation.strike_rate | locale('-')}}</div><label>SR</label></div>
                      <div><div>{{points.players[playerKey].fantasyPoints.calculation.economy_rate | locale('-')}}</div><label>Econ.</label></div>
                    </div>
                    <div class="foot" alt="Last updated Match Time">
                      <small>{{points.players[playerKey].fantasyPoints.lastUpdated | simpleDateTimeString}}</small>
                    </div>
                  </template>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div v-if="state.isLoaded() && !(credit || points)">
        Fantasy information not available
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import AppEvents from '@/appevents'

export default {
  props: {
    match: Object,
  },
  data () {
    return {
      credit: null,
      points: null,
      isMiniView: false,
      state: DataState.newLoading(),
      showTeamWisePlayers: false
    }
  },
  created () {
    this.$globalEvents.$on(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  beforeDestroy () {
    this.$globalEvents.$off(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  watch: {
    'match.key' (to, from) {
      if (this.match.key !== this.match.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned (useFresh) {
      if(this.match.status.isNotStarted) {
        this.match.fantasyCredits().then(credit => {
          this.credit = credit
          this.points = null
          this.state.changeToLoaded()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      } else {
        this.match.fantasyPoints(useFresh).then(points => {
          this.credit = null
          this.points = points
          this.state.changeToLoaded()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      }
    },
    onMatchUpdated (match) {
      if(!this.state.isLoaded()) {return}
      this.onViewOpenned(true)
    },
    prepareToReopen () {
      this.credit = null
    },
    refreshView () {

    },
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
